import { get } from 'lodash-es'
import { toLocation } from './toLocation'

export const toPlace = (data: Json): TPlace => {
    const location = toLocation(data)

    return {
        placeId: get(data, 'placeId'),
        ...location,
    }
}
